<template>
  <transition name="slide-fade">
    <div
      v-if="boxData.judgeBox"
      class="scenesSetting"
      :style="{'top': boxData.fix.y - 33+'px', 'left': boxData.fix.x + 35 +'px', 'z-index': boxData.Zindex, }"
      @mousedown="
      stopDocument($event)
    "
      @mouseleave="
      setTiemAction();
    "
      @mouseover="
      stopDocument($event);
      setTiemOut();
    "
      @mouseenter="
      setTiemOut();
    "
    >
      <div class="arrowBox"></div>
      <div class="boxBody">
        <div @click="openScenesBox()">
          <i class="icon-big-plus-dark"></i>
          <span>添加</span>
        </div>
        <div @click="addScenesNew()">
          <i class="op-handle-addPic"></i>
          <span>新建</span>
        </div>
        <div @click="copyScenes()" v-analysis="ANALYSIS.copyScenes">
          <i class="copyScenes"></i>
          <span>复制</span>
        </div>
        <div @click="collectScenes()" v-analysis="ANALYSIS.collectScenes">
          <i class="likeScenes"></i>
          <span>收藏</span>
        </div>
        <div @click="delScenes()">
          <i class="icon-sprite-delete"></i>
          <span>删除</span>
        </div>
        <div @click="addScenes()" v-analysis="ANALYSIS.addScenesLast">
          <i class="addScenes"></i>
          <span>继续创作</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import durationLimitMixin from '../tool/timeline/limitMixin.vue';

export default {
  mixins: [durationLimitMixin],
  data() {
    return {
      ANALYSIS: {
        copyScenes: {
          category: "resource_scene",
          action: "click_copy_current_scene",
          label: "资源设置_场景_添加_复制当前场景页"
        },
        collectScenes: {
          category: "resource_scene",
          action: "click_favorite",
          label: "资源设置_场景_收藏"
        },
        addScenesLast: {
          category: "resource_scene",
          action: "click_copy_last_frame",
          label: "资源设置_场景_添加_复制最后一帧"
        }
      },
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        moveoks: false, // 拖动判读啊数据
        oldMove: {
          // 计算移动增量
          x: 0,
          y: 0
        },
        fix: {
          // 弹窗位置
          x: 0,
          y: 0
        }
      },
      sprite: {}, // 选中的分组
      setTime: null // 事件判断
    };
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "scenesSetting");
      this.boxData.judgeBox =
        num < 0 ? false : "scenesSetting" in this.dataMsg ? true : false; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        this.boxData.data = this.dataMsg.scenesSetting;
        if (this.boxData.data) {
          this.sprite = this.boxData.data.sprite;
          this.sprite.spriteIndex = this.boxData.data.spriteIndex;
          this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
          this.boxData.fix.x = this.boxData.data.posx - 40;
          this.boxData.fix.y = this.boxData.data.posy - 8;
        } else {
          this.closeSetting();
        }
      }
    }
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "TopNav_Size",
      "SelectScenes_Msg",
      "UserEquity" // 用户权益
    ])
  },
  mounted() {
    this.$bus.on("setTimeOut_vue", data => {
      if (data.name === "scenesSetting") {
        this.setTiemAction();
      }
    });
  },
  methods: {
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    closeSetting() {
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "scenesSetting",
        type: 1
      });
    },
    setTiemAction() {
      this.setTime = setTimeout(() => {
        this.closeSetting();
      }, 1000);
    },
    setTiemOut() {
      clearTimeout(this.setTime);
      this.setTime === null;
    },
    addScenes() {
      // this.emitDurationLimit();
      // 继续创作
      // let timeAll = this.TOOL.getDuration(); //  判断时长
      // if (this.UserEquity.time && timeAll > this.UserEquity.time) {
      //   eve("totalTime_danger", null, { timeAll: timeAll });
      //   // return;
      // }

      let scenesIndex = this.SelectScenes_Msg.index + 1;
      let jsonScenes = this.cardingJson(this.SelectScenes_Msg.toJson());
      console.log(jsonScenes);

      this.TOOL.addScenes().then(scenes => {
        this.TOOL.moveScenesTo(scenes.id, scenesIndex);
        this.TOOL.selectScenes(scenes).then(data => {
          jsonScenes.duration = 10;
          let scale = this.TOOL.clientWidth / jsonScenes.resolution.width;
          scenes.toFromJson(jsonScenes, scale).then(() => {
            jsonScenes = null;
            this.closeSetting();
            // this.$bus.emit('spritesFlagTime', {enterTime: -1})
            this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
            // 使用复制场景页的撤销
            let data = scenes.toJson(true);
            eve("undo_redo", null, { type: "copyScenes", data: data });
          });
        });
      });
    },
    copyScenes() {
      // this.emitDurationLimit();
      // 复制分组
      // let timeAll = this.TOOL.getDuration(); //  判断时长
      // if (this.UserEquity.time && timeAll > this.UserEquity.time) {
      //   eve("totalTime_danger", null, { timeAll: timeAll });
      //   // return;
      // }
      let scenesJson = this.cardingCopyJson(this.SelectScenes_Msg.toJson());
      let scale = this.TOOL.clientWidth / scenesJson.resolution.width;
      let scenesIndex = this.SelectScenes_Msg.index + 1;
      this.TOOL.addScenes().then(scenes => {
        this.TOOL.selectScenes(scenes).then(data => {
          this.TOOL.moveScenesTo(scenes.id, scenesIndex);
          this.SelectScenes_Msg.toFromJson(scenesJson, scale).then(() => {
            // 复制进入undo栈
            let data = scenes.toJson(true);
            this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
            eve("undo_redo", null, { type: "copyScenes", data: data });

            this.closeSetting();
            scenesJson = null;
          });
        });
      });
    },
    collectScenes() {
      this.$bus.emit("collectPersonal_vue", { data: "scenesSetting" });
    },
    cardingJson(json) {
      // 梳理json存*添/
      json.resolution = {
        height: this.TOOL.clientHeight,
        width: this.TOOL.clientWidth
      };

      let duration = json.duration,
        sprites = [];
      for (let j = 0, len = json.sprites.length; j < len; j++) {
        let enterEffect = json.sprites[j].enterEffect.duration;
        let stayEffect = json.sprites[j].stayEffect.duration;
        let startTime = json.sprites[j].startTime;

        if (enterEffect + stayEffect + startTime === duration) {
          let animation = json.sprites[j].stayEffect.animationGraphs;
          json.sprites[j].startTime = 0;
          json.sprites[j].enterEffect.duration = 0;
          json.sprites[j].enterEffect.type = "None";
          json.sprites[j].stayEffect = {
            data: null,
            duration: 10, // 停留一秒钟的时候改变这个参数
            hand: undefined,
            type: "None"
          };

          if (animation) {
            json.sprites[j].outward.height = animation[0].toBounds.height;
            json.sprites[j].outward.width = animation[0].toBounds.width;
            json.sprites[j].outward.x = animation[0].toBounds.x;
            json.sprites[j].outward.y = animation[0].toBounds.y;
            json.sprites[j].outward.rotation = animation[0].toRotation;

            json.sprites[j].stayEffect.animationGraphs = null;
          }
          sprites.push(json.sprites[j]);
        }
      }
      json.sprites = sprites;

      return json;
    },
    cardingCopyJson(json) {
      // 梳理json存*添/
      json.resolution = {
        height: this.TOOL.clientHeight,
        width: this.TOOL.clientWidth
      };
      return json;
    },
    delScenes() {
      this.$bus.emit("scenesRm_vue", {
        data: this.sprite,
        index: this.sprite.spriteIndex
      });
      this.closeSetting();
    },
    addScenesNew() {
      this.$bus.emit("addScenes_vue", true);
      this.closeSetting();
    },
    openScenesBox() {
      this.$bus.emit("materialPane_vue", { type: "scenes" });
      this.closeSetting();
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scenesSetting {
  position: fixed;
  top: 0;
  left: 0;
  width: 170px;
  height: 77px;
  z-index: 35;
  border-radius: 0px 3px 3px 0px;
  // overflow: hidden;
  .arrowBox {
    position: absolute;
    top: 28px;
    left: 10px;
    bottom: 0;
    margin: auto;
    width: 6px;
    height: 6px;
    border-top: 1px solid #d8dee9;
    border-left: 1px solid #d8dee9;
    transform: rotate(-45deg);
    background: #fbfaff;
    z-index: 5;
  }
  .boxBody {
    // overflow: hidden;
    position: absolute;
    bottom: -95px;
    left: 13px;
    border: 1px solid #d8dee9;
    width: 156px;
    height: 225px;
    padding: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    background: #fbfaff;
    box-shadow: #d8dee9 0px 0px 5px 0px;
    border-radius: 5px;

    > div {
      width: 66px;
      height: 64px;
      background-color: #f0f0f8;
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #474261;

      i {
        width: 18px;
        height: 18px;
        margin-bottom: 2px;
      }
    }
    .copyScenes {
      background: url("../../../static/svg/copy.svg") no-repeat center;
      &:hover {
        background: url("../../../static/svg/copy-active.svg") no-repeat center;
      }
    }
    .likeScenes {
      background: url("../../../static/svg/heart.svg") no-repeat center;
      &:hover {
        background: url("../../../static/svg/heart-active.svg") no-repeat center;
      }
    }
    .addScenes {
      background: url("../../../static/svg/continue-create.svg") no-repeat
        center;
      &:hover {
        background: url("../../../static/svg/continue-create-active.svg")
          no-repeat center;
      }
    }
    .op-handle-addPic {
      background-image: url("../../../static/svg/add-new-scenes-active.svg");

      &:hover {
        background-image: url("../../../static/svg/add-new-scenes.svg");
      }
    }
    .icon-sprite-delete {
      &:hover {
        background-image: url("../../../static/svg/delete-active.svg");
      }
    }
    .icon-big-plus-dark {
      background-image: url("../../../static/svg/round-add.svg");

      &:hover {
        background-image: url("../../../static/svg/round-add-active.svg");
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(15px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/scenesSetting.vue